export const slotsCasinoFetchTimer = 300000; //5 * 60 * 1000
export const slotBattlesFetchTimer = 300000; //5 * 60 * 1000
export const slotBattlesBannerFetchTimer = 900000; //15 * 60 * 1000